<template id="headerbar">
    <div class="header">
        <div class="container">
            <div v-if="stepId != 0" class="back" @click="goPrev"> <span class="icon icon-dropdown_up"></span> <span class="text">Indietro</span></div>
            <div v-if="stepId != 0" class="decoration"></div>
            <!-- <div class="progress">Domanda <strong><span class="stepnumber">{{ stepflow.length }}</span></strong> <span class="of"></span></div> -->        
            <div id="steptitle" :class="[(stepId == 0) ? 'steptitle first' : 'steptitle']" >{{ headerLabel }} <span v-if="stepId == 0" class="commodity">{{ preselection }}</span>
                <!-- <span class="stepid">id: {{ stepId }}</span> -->
            </div>

            <div class="sf-close" sf-cart-modal-close @click="closeCartStep()">
                <span></span>
                <span></span>
            </div>
            
        </div>
        <div class="progressbar">
            <div id="filler" class="filler"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Headerbar",

    props: ['preselection', 'stepflow', 'headerLabel', 'stepId'],
    data: function () {
        return {
            value: -1
        };
    },
    created: function () {
        this.value = -1;
    },

    beforeMount: function () {
        this.value = -1;
    },

    methods: {
        closeCartStep: function () {
            document.getElementById('cart-step').classList.remove('open');
        },
        goPrev: function () {
            this.$emit('go-prev');
        },
    }
}
</script>